import Create from './create/CreatePhysicalDistributionSectionTemplate';
import Edit from './edit/EditPhysicalDistributionSectionTemplate';
import Individual from './individual/PhysicalDistributionTemplateSection';

export default { Create, Individual, Edit };
